import React from "react";
import { useState } from "react";
import "./LanguageDropdown.css";
import { useRef } from "react";
import { useEffect } from "react";
import { ICON } from "../../../assets";
import UiIcon from "../../ui/UiIcon";

function LanguageDropdown({ currentLanguage, onLanguageSelect = () => {} }) {
  const languagesConfig = [
    { code: "fr", label: "français" }
  ];

  const [selectedLang, setSelectedLanguage] = useState(currentLanguage);

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleOptionClick = (langCode) => {
    const selectValue = languagesConfig.find(
      (lang) => lang.code === langCode,
    ).code;
    onLanguageSelect(selectValue);
    setSelectedLanguage(selectValue);
    setIsOpen(false);
  };

  const selectedLanguage = languagesConfig.find(
    (lang) => lang.code === selectedLang,
  );

  return (
    <React.Fragment>
      <div className="language-dropdown" ref={buttonRef}>
        <div
          className={`dropdown-selected ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
          role="combobox"
          aria-expanded={isOpen}
          aria-haspopup="listbox"
          tabIndex="0"
          ref={dropdownRef}
        >
          {selectedLanguage?.label}
          <span className="dropdown-arrow">
            <UiIcon
              size="md"
              icon={`${isOpen ? ICON.arrowUpIcon : ICON.arrowDownIcon}`}
              alt="arrow"
            />
          </span>
        </div>
        {isOpen && (
          <ul className="dropdown-options" role="listbox">
            {languagesConfig
              .filter((lang) => lang.code !== selectedLang)
              .map((lang) => (
                <li
                  key={lang.code}
                  className="dropdown-option"
                  onClick={() => handleOptionClick(lang.code)}
                  role="option"
                  aria-selected={selectedLang === lang.code}
                  tabIndex="0"
                >
                  {lang.label}
                </li>
              ))}
          </ul>
        )}
      </div>
    </React.Fragment>
  );
}

export default LanguageDropdown;
